import { Controller } from "react-hook-form";
import TextField from "@mui/material/TextField";

import { handleInputEvent } from "../utils";
import { FormHelperText } from "@mui/material";

export interface FormInputProps {
  control: any;
  name: string;
  helper?: any;
  label?: string;
  style?: any;
  inputType?: any;
  placeholder?: string;
  fieldValue?: string;
  accept?: string;
  disabled?: boolean;
}

export const FormInputText = ({
  control,
  name,
  helper,
  label,
  style,
  inputType,
  placeholder,
  accept,
  disabled,
}: FormInputProps) => {
  return (
    <>
      <Controller
        name={name}
        control={control}
        defaultValue={""}
        rules={helper}
        render={({
          field: { onChange, value, ref, onBlur },
          fieldState: { error },
        }) => (
          <>
            <TextField
              required={true}
              error={error !== undefined}
              placeholder={placeholder || ""}
              disabled={disabled}
              sx={{
                ...style,
              }}
              onChange={(e) => {
                if (inputType === "file") {
                  const target = e.target as HTMLInputElement;
                  const file =
                    target.files && target.files[0] ? target.files[0] : null;
                  onChange(file);
                } else {
                  onChange(e.target.value);
                }
              }}
              onInput={(e) => {
                handleInputEvent(e, inputType);
              }}
              value={inputType === "file" ? undefined : value || ""}
              onBlur={onBlur}
              inputRef={(el) => {
                if (el && inputType === "file" && accept) {
                  el.accept = accept;
                }
                ref(el);
              }}
              variant="outlined"
              label={label ? label : ""}
              type={inputType || "text"}
            />
            {error && error.message && (
              <FormHelperText>{error ? error.message : null}</FormHelperText>
            )}
          </>
        )}
      />
    </>
  );
};
